module.exports = __webpack_public_path__ + "img/icon-amount-pellets-default.cdb7c6b.svg";